import React from "react";
import { withStyles } from "@mui/styles";

const styles = (theme) => ({
  formHeader: {
    fontSize: 15,
    marginBottom: 10,
  },
});

function FormHeader({ classes, children }) {
  return <div className={classes.formHeader}>{children}</div>;
}

export default withStyles(styles)(FormHeader);
